<ng-template #buttonTemplate class="col-12 row">
  <div class="col-12 row" style="position: relative">
    <div class="col-12 d-grid noPR">
      <button
        [routerLink]="routeImportPickups"
        class="btn btnYellow"
        (click)="clickImport()"
      >
        <i class="dhlicon dhlicon-importdhl"></i>
        <span class="hideMobile">
          &nbsp; {{ 'SHARED.IMPORT' | translate }}</span
        >
      </button>
    </div>
  </div>
</ng-template>
<ng-template
  #busqueda
  let-metadata="metadata"
  let-frm="frm"
  class="side-body row"
>
  <ng-container [formGroup]="frm">
    <!-- Fila búsqueda y opciones -->
    <div class="col-12 noPR topFilters">
      <div class="main-filter">
        <shared-period-condition
          formControlName="Days"
        ></shared-period-condition>
      </div>
      <div class="main-filter">
        <shared-date-condition
          #from
          [to]="to"
          [text]="metadata?.Search.Properties['From'].Text"
          formControlName="From"
        ></shared-date-condition>
      </div>
      <div class="main-filter">
        <shared-date-condition
          #to
          [from]="from"
          [text]="metadata?.Search.Properties['To'].Text"
          formControlName="To"
        ></shared-date-condition>
      </div>
      <div class="main-filter">
        <shared-account-condition
          formControlName="Accounts"
          class="accountNumber"
        ></shared-account-condition>
      </div>
      <div class="main-filter">
        <shared-condition
          [text]="metadata?.Search.Properties['ImportStatus'].Text"
          formControlName="ImportStatus"
          [options]="importStatus"
        ></shared-condition>
      </div>
    </div>
  </ng-container>
</ng-template>
<common-user-view
  #b
  [buttonTemplate]="buttonTemplate"
  [searchTemplate]="busqueda"
  [gridContext]="this"
  [buttonsColClass]="'col-sm-4'"
  [colClass]="'col-sm-8 pe-4'">
  class="searchPickups"
>
</common-user-view>
